/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, October 5th 2021, 12:03:34 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OrganizationListItem } from "lib/schemas";
import { ProgressWrapper, EmptyListWrapper, APIErrorWrapper } from "ui-widgets";
import { useAPIFetchOrganizationsList } from "organizations/services/OrganizationsAPI";

interface OrganizationsListProps {
  renderOrganizationList: (organizations: OrganizationListItem[]) => React.ReactNode;
}

export const OrganizationsList = ({ renderOrganizationList }: OrganizationsListProps) => {
  const {
    items: organizations,
    isMakingAPIRequest,
    isAPIError,
    httpResponseStatusCode,
  } = useAPIFetchOrganizationsList({
    makeRequestOnInitialMount: true,
  });

  return (
    <ProgressWrapper showLoader={isMakingAPIRequest}>
      <APIErrorWrapper
        isAPIError={isAPIError}
        errorMessage="We cannot retrieve your organizations at the moment, please try again later."
        httpResponseStatusCode={httpResponseStatusCode}
      >
        <EmptyListWrapper items={organizations} noDataMessage="No Organizations Found">
          {renderOrganizationList(organizations)}
        </EmptyListWrapper>
      </APIErrorWrapper>
    </ProgressWrapper>
  );
};
